import { Component } from 'react';
import { withRouter } from 'react-router';

/*
 * CORA — the PCAI / PowerConnect customer chatbot.
 *
 * The widget script is loaded once from public/index.html (it defines the
 * <pcai-chatbot> custom element). This component renders that element — the
 * floating launcher — on the public-facing site only, and NOT on the internal
 * admin / CMS pages. It is mounted once at the app level (outside the route
 * Switch) so the conversation persists as visitors move between public pages;
 * on an admin route it renders nothing, so no launcher appears there.
 *
 * ADMIN_PATH_PREFIXES must stay in sync with the AuthorizeAdminRoute paths in
 * App.js (add new admin pages here). Matching mirrors the router: an admin
 * page is an exact match or a "<prefix>/..." child path.
 */
const ADMIN_PATH_PREFIXES = [
    '/PageComponentManagement', '/CreatePage', '/UpdatePage', '/CreateExternalPage',
    '/UpdateExternalPage', '/UpdatePageComponent', '/AdminHome', '/Settings',
    '/LayoutManagement', '/FormBuilderManagement', '/CreateForm', '/FormBuilder',
    '/FormBuilderSubmissions', '/FormBuilderSingleSubmission', '/SecureSubmissions',
    '/AuditLog', '/TracSoftSettings', '/PagePreview', '/UserManagement', '/CreateUser',
    '/UpdateUser', '/RoleManagement', '/DocumentManagement', '/DocumentDeletion',
    '/CreateDocument', '/UpdateDocument', '/EventManagement', '/EventDeletion',
    '/CreateEvent', '/UpdateEvent', '/BlogManagement', '/CreateBlog', '/UpdateBlog',
    '/PreviewBlog', '/NewsManagement', '/CreateNews', '/UpdateNews', '/BirthdayManagement',
    '/ImageManagement', '/ImageDeletion', '/SideNavManagement', '/CreateSideNav',
    '/UpdateSideNav', '/Login', '/authentication'
];

function isAdminPath(pathname) {
    const path = (pathname || '/').toLowerCase();
    return ADMIN_PATH_PREFIXES.some(prefix => {
        const p = prefix.toLowerCase();
        return path === p || path.startsWith(p + '/');
    });
}

class Chatbot extends Component {
    render() {
        if (isAdminPath(this.props.location.pathname)) {
            return null;
        }

        return (
            <pcai-chatbot
                agent_id="pcai_3668db234c524bc5a24b81bd6d8672d7"
                src="https://cwwgabot.powerconnect.ai/plugin.es.js"
            ></pcai-chatbot>
        );
    }
}

export default withRouter(Chatbot);
